// extracted by mini-css-extract-plugin
export default {"pagi-container":"Pagination_pagi-container__wreHl","active":"Pagination_active__LXc4j"};